// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"cdae10f3","498":"2a435220","513":"2c045335","787":"cdaa849f"}[chunkId] + ".chunk.js";
};